import type { DataOf } from '@elara/firebolt/shared';

import { collectionPath, defineModelSpec } from '@elara/firebolt/shared';

import { RoomOptionSchema } from './schemas/room-schemas.js';
import { id, tripId } from './schemas/zod-types.js';

/**
 * ModelSpec for the room-options subcollection within a trip.
 * Path: trips/{tripId}/room-options/{id}.
 * Room options are persisted when fetchRoomAvailability runs so shortlist and itinerary can reference them by id.
 */
export const RoomOptionModelSpec = defineModelSpec({
  path: collectionPath`trips/${tripId}/room-options/${id}`,
  shape: RoomOptionSchema.shape,
});

export type RoomOptionModelSpec = typeof RoomOptionModelSpec;
export interface RoomOptionData extends DataOf<RoomOptionModelSpec> {}
